import React from 'react'
import OverHead from "./OverHead"
import BrighterD from "./BrighterD"
import System from './System'
import Find from './Find'
import Spark from "./Spark"
import Skill from "./Skill"
import Many from './Many'
import Commit from './Commit'
import Slides from "./Slides"
import Brill from './Brill'
import Footer from './Footer'

const Technologies = () => {
  return (
    <div>
        <OverHead />
        <BrighterD />
        <System />
        <Find />
        <Spark />
        <Skill />
        <Many />
        <Commit />
        <Slides />
        <Brill />
        <Footer />
    </div>
  )
}

export default Technologies